import { __extends } from "tslib";
var FetchError = /** @class */ (function (_super) {
    __extends(FetchError, _super);
    function FetchError(kind, message) {
        var _this = _super.call(this, kind + ": " + message) || this;
        _this.kind = kind;
        _this.name = 'FetchError';
        return _this;
    }
    return FetchError;
}(Error));
export { FetchError };
//# sourceMappingURL=errors.js.map